import cn from 'classnames'
export const popoverContentClassName =
   'border-1 rounded-[8px] flex flex-col w-[270px]'

export const userDetailsSectionClassName =
   'px-[16px] py-[12px] border-0 border-b'

export const adminAndFeedbackSectionClassName =
   'flex flex-col py-[6px] border-0 border-b'

export const logoutSectionContainerClassName = 'py-[6px]'

export const googleCalendarSectionContainerClassName = 'border-b'

export const getTriggerStyles = (isOpen: boolean, theme: any): string =>
   cn(`flex-shrink-0 cursor-pointer p-[8px] rounded-lg ${theme.hoverBgColor}`, {
      [theme.menuOpenedStateBgColor]: isOpen
   })

export const lastClockInSectionClassName =
   'flex justify-between px-16px py-12px border-0 border-b'
